import styled from '@emotion/styled/macro';

export const DescriptionContainer = styled.table`
    width: 100%;
    border-collapse: collapse;
`;

export const DescriptionBody = styled.tbody``;

export const TR = styled.tr``;

export const TD = styled.td`
    padding: 5px 0;
`;

export const LabelWithIcon = styled.div`
    display: flex;
    align-items: center;
`;

export const StatusIconWrapper = styled.div`
    margin-right: 5px;
    display: flex;
`;
